import React from 'react';

export const licensesMap = {
  //['CC BY-SA 3.0']: (<a href="/by-sa.3.0.txt">Creative Commons Attribution-Share-Alike License 3.0</a>)
  ['CC BY-SA 3.0']: (<a href="/by-sa.3.0.txt">CC BY-SA 3.0</a>) //replace with shorter label?
};